import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'ui-shared';

@Injectable({
  providedIn: 'root'
})
export class IdentidadeGuard  {
  constructor(private router: Router,
    @Inject(LoginService) private loginService: LoginService
  ) { }

  canActivate() {
    if (!this.loginService.estaLogado()) {
      this.router.navigate(['/login']);
      return false;
    }
    else if (!this.loginService.suporte) {
      return this.router.navigate(['acesso-negado']);
    }
    return true;
  }
}
